import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';
import TextAdjustLengthIcon from '@atlaskit/icon-lab/core/text-adjust-length';
import { fg } from '@atlaskit/platform-feature-flags';
import { expValEqualsNoExposure } from '@atlaskit/tmp-editor-statsig/exp-val-equals-no-exposure';

import { MakeShorterIcon } from '../../../../icons/prompt/makeShorter';
import type { ConvoAiFeatureId } from '../../../../utils/request/types';
import { createInsertBelow, createReplace } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemWithOptions,
	EditorPluginAIConfigItem,
} from '../../config-items';

export const makeShorter: () => EditorPluginAIConfigItem = () => {
	let featureId: ConvoAiFeatureId = 'make_shorter';
	let adfPrompt = false;
	if (
		expValEqualsNoExposure('platform_editor_ai_non_iw_adf_streaming', 'cohort', 'adf_gpt41mini')
	) {
		featureId = 'make_shorter_adf_gpt41mini';
		adfPrompt = true;
	} else if (
		expValEqualsNoExposure(
			'platform_editor_ai_non_iw_adf_streaming',
			'cohort',
			'adf_gemini25flash',
		) ||
		fg('platform_editor_ai_updated_adf_prompts_v111')
	) {
		featureId = 'make_shorter_adf_v111';
		adfPrompt = true;
	} else if (fg('platform_editor_ai_updated_adf_prompts')) {
		featureId = 'make_shorter_adf_v11';
		adfPrompt = true;
	}

	return {
		key: CONFIG_ITEM_KEYS.MAKE_SHORTER,
		title: aiConfigItemMessages.makeShorterTitle,
		description: aiConfigItemMessages.makeShorterDescription,
		icon: () => <MakeShorterIcon />,
		showInRefineDropdown: true,
		intentSchemaId: 'shorten_intent_schema.json',
		featureId,
		adfPrompt,
		requiresTextualContent: adfPrompt,
		actions: {
			empty: [
				createInsertBelow({ appearance: 'secondary' }),
				createReplace({ appearance: 'primary' }),
			],
			selection: [
				createInsertBelow({ appearance: 'secondary' }),
				createReplace({ appearance: 'primary' }),
			],
		},
		getBackendModel: () => {
			return 'assistance-service';
		},
		get nestingConfig() {
			if (fg('aifc_create_enabled')) {
				return {
					id: 'adjust-length',
					parentTestId: 'adjust-length',
					parentTitle: aiConfigItemMessages.adjustLengthNestingParentTitle,
					shortTitle: aiConfigItemMessages.adjustLengthNestingParentShortTitle,
					icon: () => <TextAdjustLengthIcon label="" spacing="spacious" />,
				};
			}
			return undefined;
		},
	};
};

export const makeShorterWithOptions: () => EditorPluginAIConfigItemWithOptions = () => ({
	config: makeShorter(),
	triggers: { empty: { enabled: true, docMinSize: 1 }, selection: { enabled: true } },
});
